import React from 'react';
import { PotatoChip, Sparkle } from './PotatoSVG';
import { getSite } from '../siteConfig';

const About = () => {
  const stats = [1,2,3].map(i => ({ num:getSite(`about_stat_${i}_num`, ['50+','150+','10x'][i-1]), label:getSite(`about_stat_${i}_label`, ['Brands','Successful Campaigns','ROAS'][i-1]) }));
  const paras = [1,2,3,4].map(i => getSite(`about_p${i}`, [
    'Back in 2019, two school friends from Indore came together with a simple idea: help brands get seen, noticed and remembered online.',
    'That idea became Social Potato.',
    'What started as a small team has grown into a digital marketing agency helping businesses build their presence through smart strategy, creative content and work that actually connects with people.',
    'We’re here to make brands more visible, more relevant and impossible to scroll past.'
  ][i-1]));
  return (
    <section id="about" className="relative bg-[#111] text-white py-20 md:py-32 overflow-hidden">
      <div data-testid="established-stat" className="px-6 md:px-0 mb-10 md:mb-0 md:absolute md:top-20 md:right-24">
        <p className="text-[10px] md:text-xs uppercase tracking-widest text-white/50">Established</p>
        <p className="font-display font-extrabold text-4xl md:text-6xl text-[#FFD200]">{getSite('about_established','2019')}</p>
      </div>
      <Sparkle className="absolute top-10 left-10 w-6 h-6 float-slow" color="#FFD200" />
      <PotatoChip className="absolute bottom-10 right-10 w-20 h-20 float-fast" />
      <div className="px-6 md:px-16 max-w-6xl">
        <p className="text-xs uppercase tracking-[0.3em] text-[#FFD200] mb-3">{getSite('about_kicker','nurturing brands')}</p>
        <h2 className="font-display font-extrabold text-4xl md:text-7xl lowercase leading-[0.95] mb-10">
          {getSite('about_heading_before','growing brands to thrive in the')} <span className="yellow-brush !bg-[#FFD200]/90 text-black">{getSite('about_heading_highlight','intelligent')}</span> {getSite('about_heading_after','era')}
        </h2>
        <div className="grid grid-cols-3 gap-3 md:gap-6 my-10 md:my-16">
          {stats.map((v,i)=><div key={i} className="group border border-white/20 rounded-2xl p-4 md:p-8 transition-colors cursor-default hover:bg-[#FFD200]">
            <p className="text-[10px] uppercase tracking-widest text-white/60 group-hover:text-black/60 transition-colors">0{i+1}</p>
            <p className="font-display font-extrabold text-3xl sm:text-4xl md:text-6xl mt-2 md:mt-3 text-[#FFD200] group-hover:text-black transition-colors">{v.num}</p>
            <p className="font-body text-[10px] sm:text-sm md:text-base mt-2 text-white/80 group-hover:text-black transition-colors uppercase tracking-wider font-semibold">{v.label}</p>
          </div>)}
        </div>
        <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-start">
          <div><p className="text-xs uppercase tracking-[0.3em] text-[#FFD200] mb-3">{getSite('about_label','about us')}</p><h3 className="font-display font-extrabold text-3xl md:text-5xl lowercase mb-6">{getSite('about_title','Every good story starts with a bad idea…')}</h3></div>
          <div className="space-y-4 text-white/80 text-base md:text-lg leading-relaxed">{paras.map((p,i)=><p key={i}>{p}</p>)}</div>
        </div>
      </div>
    </section>
  );
};
export default About;
